import createModel, { prop } from '../lib/create_model';

export default createModel({
  modelName: 'EmbeddedReport',
  properties: {
    expiringUrl: prop(ExpiringUrl),
    metricSet: prop(),
    supportedFilters: prop([String]),
    timezone: prop(String).default('America/New_York'),
    // client-side only
    hasUsedUrl: prop(Boolean).default(false),
  },

  useUrl() {
    this.hasUsedUrl = true;
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export const ExpiringUrl = createModel({
  modelName: 'ExpiringURL',
  properties: {
    url: prop(String),
    expiry: prop(String),
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/reports/embedded_report.js